import { render, staticRenderFns } from "./list_statis_wenda.vue?vue&type=template&id=9ab4cc1c&scoped=true&"
import script from "./list_statis_wenda.vue?vue&type=script&lang=js&"
export * from "./list_statis_wenda.vue?vue&type=script&lang=js&"
import style0 from "./list_statis_wenda.vue?vue&type=style&index=0&id=9ab4cc1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ab4cc1c",
  null
  
)

export default component.exports